import { render, staticRenderFns } from "./InventoryTracing.vue?vue&type=template&id=24580dd0"
import script from "./InventoryTracing.vue?vue&type=script&lang=js"
export * from "./InventoryTracing.vue?vue&type=script&lang=js"
import style0 from "./InventoryTracing.vue?vue&type=style&index=0&id=24580dd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports